import { AuthCookies } from 'mroshopcommon/src/utils/cookie';
/*
 * @Author: hzm
 * @Date: 2022-11-22 12:49:11
 * @Description:
 */

class Auth extends AuthCookies {
  constructor() {
    super('Zdshop-Token');
  }
}

export default new Auth();
